// eslint-disable-next-line no-use-before-define
import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { LoadingContainer, StageLoadingContainer } from './style';
/** Logo publicada pelo webpack ao lado do `index.html` (`static/`). */
export const CORA_LOGO_URL = 'logo-cora.svg';
export const LoadingComponent = ({ loading }) => {
    const { t } = useTranslation('loading');
    if (!loading) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(LoadingContainer, null,
        React.createElement("div", { className: "root-app_loading-container", role: "status", "aria-live": "polite" },
            React.createElement("div", { className: "root-app_loading" },
                React.createElement("img", { className: "root-app_loading-logo", src: CORA_LOGO_URL, alt: "" }),
                React.createElement("div", { className: "root-app_loading-bar" }),
                React.createElement("span", { className: "root-app_loading-label" }, t('loading:label'))))));
};
/**
 * Loading da troca de tela: o mesmo visual, mas só sobre o palco (o iframe do
 * MFE), com o menu visível.
 */
export const StageLoadingComponent = ({ stageLoading, }) => {
    const { t } = useTranslation('loading');
    const stage = document.getElementById('root-app_side_content');
    if (!stageLoading || !stage) {
        return React.createElement(React.Fragment, null);
    }
    return ReactDOM.createPortal(React.createElement(StageLoadingContainer, { className: "root-app_stage-loading", role: "status", "aria-live": "polite" },
        React.createElement("img", { className: "root-app_loading-logo", src: CORA_LOGO_URL, alt: "" }),
        React.createElement("div", { className: "root-app_loading-bar" }),
        React.createElement("span", { className: "root-app_loading-label" }, t('loading:label'))), stage);
};
//# sourceMappingURL=component.js.map